export default "__VITE_ASSET__be72e296__"